const { use } = require("marked");

function insertFirebaseUploader(loan) {
  let useFirebaseUploader = false;

  if (loan.id > 16740) {
    useFirebaseUploader = true;
  }

  return useFirebaseUploader;
}

export default insertFirebaseUploader;
